import { useEffect } from 'react';
import { queryService } from '../../../services/queryService';
import { useSnackbar } from '../../../components/common/Snackbar';
import { TIME_UPDATE_INTERVAL } from '../../../constants/slaDashboard';

/**
 * Hook to manage query data fetching and time updates for SLADashboard page
 * @param {Function} setQueries - Setter for queries
 * @param {Function} setLoading - Setter for loading state
 * @param {Function} setNow - Setter for current time
 * @returns {Function} Fetch queries function
 */
export const useSLADashboardData = (setQueries, setLoading, setNow) => {
  const { showSnackbar } = useSnackbar();

  const fetchQueries = async () => {
    setLoading(true);
    try {
      const data = await queryService.getAllQueries({}, 200, 20);
      // Verify we're getting real data
      // console.log('SLA Dashboard: Fetched queries', data.length, 'queries');
      if (data.length > 0) {
        // console.log('Sample query data:', {
          // id: data[0].queryId || data[0]._id,
          // slaDueDate: data[0].slaDueDate,
          // raisedAt: data[0].raisedAt,
          // respondedAt: data[0].respondedAt,
          // closedAt: data[0].closedAt,
        // });
      }
      setQueries(data);
      // Update now when data is fetched to ensure fresh calculations
      setNow(new Date());
    } catch (error) {
      // console.error('Failed to load SLA dashboard data:', error);
      const message = error.response?.data?.message || 'Failed to load SLA data';
      showSnackbar(message, 'error');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchQueries();
    // Update current time every minute to ensure real-time calculations
    const interval = setInterval(() => {
      setNow(new Date());
    }, TIME_UPDATE_INTERVAL);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    fetchQueries,
  };
};
